import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Clipboard } from '@capacitor/clipboard';
import { ModalController } from '@ionic/angular';
import { ProjectBillingDetails } from '../../billing/project-billing-details';

@Component({
  selector: 'ui-billing-info-modal',
  templateUrl: './billing-info-modal.component.html',
  styleUrls: ['./billing-info-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BillingInfoModalComponent {
  @Input() billingDetails?: ProjectBillingDetails;

  constructor(private readonly modalController: ModalController) {}

  async copyBillingDetails(): Promise<void> {
    const text = this.buildBillingDetailsText();

    if (!text) {
      return;
    }

    await Clipboard.write({ string: text });
  }

  close(): void {
    this.modalController.dismiss(undefined, 'ok');
  }

  private buildBillingDetailsText(): string {
    const details = this.billingDetails;
    if (!details) {
      return '';
    }

    const lines = [
      details.legalName ? `Ragione sociale: ${details.legalName}` : undefined,
      details.address ? `Indirizzo: ${details.address}` : undefined,
      details.zipCode || details.city
        ? `CAP/Città: ${[details.zipCode, details.city]
            .filter((value): value is string => Boolean(value))
            .join(' ')}`
        : undefined,
      details.vatNumber ? `P.IVA: ${details.vatNumber}` : undefined,
      details.recipientCode
        ? `Codice destinatario: ${details.recipientCode}`
        : undefined,
      details.projectCode
        ? `Codice progetto: ${details.projectCode}`
        : undefined,
      details.projectName ? `Progetto: ${details.projectName}` : undefined,
    ];

    return lines.filter((line): line is string => Boolean(line)).join('\n');
  }
}
